(ns rothko.editor.document
  (:require [rothko.editor.document.script :as script]
            [rothko.editor.document.history.linear :as history]))

(defn scripts->document
  [script original-script]
  (-> {:script script
       :selection (script/caret 0 0)}
      history/attach-to-document
      (assoc :original-script original-script)))

(defn unchanged?
  [{:keys [original-script script]}]
  (= original-script script))
